export default {
      id: "reports-usage",
      viewBox: "0 0 86 70",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#reports-usage",
      toString: function () {
        return this.url;
      }
    }